import React, { useContext } from 'react';
import AppContext from 'context/Context';

const TicketsFilterTabs = ({ filterTab, setFilterTab, counts = {} }) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const { todos = 0, pendientes = 0, enProgreso = 0, cerrados = 0 } = counts;

  const tabs = [
    { id: 'todos', label: 'Todos', count: todos },
    { id: 'pendientes', label: 'Pendientes', count: pendientes },
    { id: 'en_progreso', label: 'En Progreso', count: enProgreso },
    { id: 'cerrados', label: 'Resueltos', count: cerrados }
  ];

  return (
    <div
      className="d-flex align-items-center gap-1 p-1 rounded-2 flex-wrap"
      style={{
        backgroundColor: isDark ? '#0b1727' : '#f1f5f9',
        border: isDark ? '1px solid #233142' : '1px solid #e2e8f0'
      }}
    >
      {tabs.map(tab => {
        const isActive = filterTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => setFilterTab(tab.id)}
            className="btn btn-sm px-3 py-1 rounded-2 border-0 transition-base"
            style={{
              fontSize: '0.82rem',
              fontWeight: isActive ? 700 : 500,
              backgroundColor: isActive
                ? (isDark ? '#121e2d' : '#ffffff')
                : 'transparent',
              color: isActive
                ? (isDark ? '#f9fafd' : '#0f172a')
                : (isDark ? '#94a3b8' : '#64748b'),
              boxShadow: isActive
                ? (isDark ? '0 1px 3px rgba(0,0,0,0.4)' : '0 1px 2px rgba(0,0,0,0.08)')
                : 'none'
            }}
          >
            {tab.label} ({tab.count ?? 0})
          </button>
        );
      })}
    </div>
  );
};

export default TicketsFilterTabs;
